// extracted by mini-css-extract-plugin
module.exports = {"timeleft":"TimeleftCell-timeleft-2x5A_ TableRowCell-cell-2fbg4"};